import {
  GET_RAFT_BY_BADGE,
  GET_RAFT_BY_RAFID,
  GET_ACADEMIC_GRADES,
  GET_ENGLISH_LEVEL,
  GET_PAYMENT_METHOD,
  GET_POSITIONS,
  RE_LOADING,
  ADD_RAFT,
  VALIDATION_RAFT,
  RE_LOADING_VALIDATION,
  RE_ERROR,
  GET_LAST_REFERRALS,
  GET_LOCATIONS,
  GET_PROMOTIONAL_CODES,
  UPLOAD_FILE_RAFT,
  GET_SETTINGS,
} from "../actions/RaftActions";


const initialState = {
  raftlist: [],
  academicgrades: [],
  englishlevel: [],
  paymentmethods: [],
  positions: [],
  raftbyraftid: [],
  lastreferrals: [],
  locations: [],
  codes: [],
  settings: [],
  fileurl: null,
  validation: false,
  validationData: [],
  loading: false,
  loadingvalidation: false,
  success: true,
};

const RaftReducer = function(state = initialState, action) {
  switch (action.type) {
      case RE_LOADING: {
        return {
          ...state,
          loading: true
        };
      }
      case RE_LOADING_VALIDATION: {
        return {
          ...state,
          validation: false,
          loadingvalidation: true
        };
      }
      case RE_ERROR: {
        return {
            ...state,
            validation : false,
            validationData: action.data,
            success: false,
            loadingvalidation: false,
            loading: false,
        }
      }
      case GET_RAFT_BY_BADGE: {
          return {
              ...state,
              raftlist : action.data,
              loading: false
          }
      }
      case VALIDATION_RAFT: {
        return {
            ...state,
            validation : action.data,
            loadingvalidation: false
        }
      }
      case GET_ACADEMIC_GRADES: {
        return{
            ...state,
            academicgrades : [...action.data],
            loading: false
        }
      }
      case GET_SETTINGS: {
        return{
            ...state,
            settings : [...action.data],
            loading: false
        }
      }
      case GET_LOCATIONS: {
        return{
            ...state,
            locations : [...action.data],
            loading: false
        }
      }
      case GET_PROMOTIONAL_CODES: {
        return{
            ...state,
            codes : [...action.data],
            loading: false
        }
      }
      case GET_LAST_REFERRALS: {
        return{
            ...state,
            lastreferrals : [...action.data],
            loading: false
        }
      }
      case GET_PAYMENT_METHOD: {
        return{
            ...state,
            paymentmethods : [...action.data],
            loading: false
        }
      }
      case GET_POSITIONS: {
        return{
            ...state,
            positions : action.data,
            loading: false,
        }
      }
      case GET_ENGLISH_LEVEL: {
        return{
            ...state,
            englishlevel : [...action.data],
            loading: false
        }
      }
      case GET_RAFT_BY_RAFID: {
          return{
            ...state,
            raftbyraftid: [...action.data],
            loading: false
          }
      }
      case ADD_RAFT: {
        return {
          ...state,
          loading: false,
          success: action.data.success 
        };
      }
      case UPLOAD_FILE_RAFT: {
        return {
          ...state,
          fileurl: action.data,
          loading: false  
        };
      }
      default: {
          return state;
        }
      }
}

export default RaftReducer;
